import {mapFieldArrToObjSchema} from "../../validation/useValidation";



export const FormTagInit = {
    name: "",
};

const tagValidationsArr = [
    ['name', 'string'],
];


export const tagValidations = mapFieldArrToObjSchema(tagValidationsArr);